// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { SegmentAirFieldsetComponent } from './segment-air-fieldset.component';
import { ReactiveFormsModule } from '@angular/forms';
import { Date2MonthsModule } from '../../fields/date2months-field/date2months.module';
import { NumberFieldModule } from '../../fields/number-field/number-field.module';
import { TextFieldModule } from '../../fields/text-field/text-field.module';
import { ButtonModule } from '../../fields/button/button.module';
import {DateModule} from "../../fields/date/date.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { CheckboxFieldModule } from "libraries/module/formbuilder/fields/checkbox-field/checkbox-field.module";
import { AirportSelectModule } from "libraries/component/airport-select/airport-select.module";
import { BtnModule } from 'libraries/ui_button/btn.module';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        Date2MonthsModule,
        NumberFieldModule,
        TextFieldModule,
        ButtonModule,
        DateModule,
        FontAwesomeModule,
        CheckboxFieldModule,
        AirportSelectModule,
        BtnModule,
    ],
    declarations: [
        SegmentAirFieldsetComponent,
    ],
    exports: [
        SegmentAirFieldsetComponent,
    ],
    providers: [],
})
export class SegmentAirFieldsetModule {}
